import api from '@/store/API/QuilityAPI'

import { getInnerId } from '../config/index'

type Options = { // TODO: check
	division: string,
	status: string,
	itemsPerPage: number,
	page: number,
	search: string,
	sortBy: string[],
	sortDesc: boolean[],
}

type Topic = {
	id: string | number,
	title: string,
	description: string,
	buttonTitle: string,
	buttonLink: string,
	roles: string | null,
	permissions: string | null,
	status: string,
	publishDate: string | null,
	endDate: string | null,
}

type Category = {
	id: string | number,
	title: string,
	status: string,
	publishDate: string | null,
	endDate: string | null,
	topics: Topic[],
}

type Page = {
	id: string | number,
	title: string,
	slug: string,
	division: string | null,
	status: string,
	description: string,
	categories: Category[],
	lastChangeBy: string,
	dateCreated: string | null,
	dateUpdated: string | null,
}

type Response = {
	data: Page | Page[],
	meta: {
		total: number,
		filters: Record<string, string[] | (string | Record<string, string>)[]>,
	}
}

type ErrorResponse = {
	error: Error,
	message?: string,
}

// Fake data -----
const topic = {
	id: 0,
	title: 'Test Topic',
	description: 'Some Topic description',
	buttonTitle: 'Open Topic',
	buttonLink: '/page/test-topic',
	roles: null,
	permissions: null,
	status: 'Draft',
	publishDate: null,
	endDate: null,
}
const getTopic = (id = getInnerId()):Topic => ({
	...topic,
	id,
	title: `${topic.title}-${id}`,
	status: Math.random() > 0.05 ? 'Publish' : 'Draft',
	publishDate: Math.random() > 0.05 ? '2024-05-01' : null,
})

const category = {
	id: 0,
	title: 'Test Category',
	status: 'Draft',
	publishDate: null,
	endDate: null,
	topics: [],
}
const getCategory = (id = getInnerId()):Category => ({
	...category,
	id,
	title: `${category.title}-${id}`,
	topics: [getTopic(), getTopic(), getTopic()],
	status: Math.random() > 0.05 ? 'Publish' : 'Draft',
	publishDate: Math.random() > 0.05 ? '2024-05-01' : null,
})

const page = {
	id: 0,
	title: 'Test Page',
	slug: 'test-page',
	division: 'Field, Corporate',
	status: 'Draft',
	description: 'Some Page description',
	categories: [],
	lastChangeBy: 'testagent@sfglife.com',
	dateCreated: '2024-05-01',
	dateUpdated: '2024-05-01',
}
const getPage = (id = getInnerId()):Page => ({
	...page,
	id,
	title: `${page.title}-${id}`, slug: `${page.slug}-${id}`,
	categories: [getCategory(), getCategory(), getCategory()],
	status: Math.random() > 0.05 ? 'Publish' : 'Draft',
})

const response = ():Response => ({
	data: [getPage(), getPage(), getPage()],
	meta: {
		filters: {
			Division: [
				"-All-",
				"Corporate",
				"Field"
			],
			Status: [
				"-All-",
				{
					"text": "Publish",
					"value": "publish"
				},
				{
					"text": "Draft",
					"value": "draft"
				},
				{
					"text": "Trash",
					"value": "trash"
				}
			]
		},
		total: -1,
	},
})
// Fake data -----

export const getHubPages = async (params: Options) => {
	// temporary: fake data
	if (Math.random() <= 1) {
		return new Promise((res) => {
			setTimeout(() => {
				if (Math.random() > 0.85) {
					return res({ error: 'error', message: '--error--' })
				}
				const json = response()
				return res(json)
			}, 3000)
		})
	}

	const cancelQRequestName = 'getHubPages'
	api.cancelQRequest(cancelQRequestName)
	return api.getRequest('/api/private/hubPages', params, cancelQRequestName) // TODO: check endpoint
	    .then((json) => {
			return json as Response
		})
		.catch((err) => {
			const message = err.status === 404 ? 'Page not found.' : err.message
	        return { error: err, message } as ErrorResponse
	    })
}

export const getHubPageBySlug = async (slug: string) => {
	// temporary: fake data
	if (Math.random() <= 1) {
		return new Promise((res) => {
			setTimeout(() => {
				if (Math.random() > 0.85) {
					return res({ error: 'error', message: '--error--' })
				}
				const json = getPage()
				return res(json)
			}, 3000)
		})
	}

	const cancelQRequestName = 'getHubPageBySlug'
	api.cancelQRequest(cancelQRequestName)
	return api.getRequest(`/api/private/hubPages/${slug}`, null, cancelQRequestName) // TODO: check endpoint
	    .then((json) => {
			return json.data as Page
		})
		.catch((err) => {
			const message = err.status === 404 ? 'Page not found.' : err.message
	        return { error: err, message } as ErrorResponse
	    })
}

export const createHubPage = async (page: Page) => {
	// temporary: fake data
	if (Math.random() <= 1) {
		return new Promise((res) => {
			setTimeout(() => {
				if (Math.random() > 0.85) {
					return res({ error: 'error', message: '--error--' })
				}
				return res(page)
			}, 3000)
		})
	}

	const params = { ...page }
	return api.postRequest(`/api/private/hubPages`, params) // TODO: check endpoint
	    .then((json) => {
			return json.data as Page
		})
		.catch((err) => {
			const message = err.status === 404 ? 'Page not found.' : err.message
	        return { error: err, message } as ErrorResponse
	    })
}

export const updateHubPage = async (page: Page) => {
	// temporary: fake data
	if (Math.random() <= 1) {
		return new Promise((res) => {
			setTimeout(() => {
				if (Math.random() > 0.85) {
					return res({ error: 'error', message: '--error--' })
				}
				return res(page)
			}, 3000)
		})
	}

	const params = { ...page }
	return api.putRequest(`/api/private/hubPages`, params) // TODO: check endpoint
	    .then((json) => {
			return json.data as Page
		})
		.catch((err) => {
			const message = err.status === 404 ? 'Page not found.' : err.message
	        return { error: err, message } as ErrorResponse
	    })
}

export const deleteHubPage = async (id: string) => {
	// temporary: fake data
	if (Math.random() <= 1) {
		return new Promise((res) => {
			setTimeout(() => {
				if (Math.random() > 0.85) {
					return res({ error: 'error', message: '--error--' })
				}
				return res({ id })
			}, 3000)
		})
	}

	return api.deleteRequest(`/api/private/hubPages/${id}`) // TODO: check endpoint
	    .then(() => {
			return { id }
		})
		.catch((err) => {
			const message = err.status === 404 ? 'Page not found.' : err.message
	        return { error: err, message } as ErrorResponse
	    })
}
